<template>
  <div class="mask" v-show="groupStateNotice" @click.self="closeStateNotice">
    <div class="group-notice">
      <h1>导游团体购票须知</h1>
      <div class="content">
        <p class="source">
          <span>根据北京市园林绿化局《关于动态调整公园疫情防控措施的通告》，及北京市西城区文化和旅游局《北京市西城区文化和旅游局关于在全区文化和旅游行业动态实施社会面防控措施的通知》中相关要求，</span>
          <span class="important">参加团队旅游人员（含游客、导游、司机、随团其他工作人员等全口径参团人员）应完成新冠疫苗全程接种或加强免疫接种。</span>
        </p>
        <div class="notes">
          <div class="notes-item">
            <div class="title">
              <i>*</i>
              <span>本旅游团队为本市市内旅游团。</span>
            </div>
            <div class="choice">
              <button @click="agreeInfo.isLocal = false" :class="{ 'active': agreeInfo.isLocal === false }">否</button>
              <button @click="agreeInfo.isLocal = true" :class="{ 'active': agreeInfo.isLocal }">是</button>
            </div>
          </div>
          <div class="notes-item">
            <div class="title">
              <i>*</i>
              <span>本旅游团人员（含游客、导游、司机、随团其他工作人员等全口径参团人员）均完成新冠疫苗全程接种或加强免疫接种。</span>
            </div>
            <div class="choice">
              <button @click="agreeInfo.isVaccination = false" :class="{ 'active': agreeInfo.isVaccination === false }">否</button>
              <button @click="agreeInfo.isVaccination = true" :class="{ 'active': agreeInfo.isVaccination }">是</button>
            </div>
          </div>
          <div class="notes-item">
            <div class="title">
              <i>*</i>
              <span>本旅游团人员近期身体健康，无发热、咳嗽等异常情况；无流行病学接触史；无中高风险地区14天以内旅居史；无境外回国隔离不满21天的情况;预约购票及入园时可提供72小时内核酸检测阴性。</span>
            </div>
            <div class="choice">
              <button @click="agreeInfo.isNucleicAcid = false" :class="{ 'active': agreeInfo.isNucleicAcid === false }">否</button>
              <button @click="agreeInfo.isNucleicAcid = true" :class="{ 'active': agreeInfo.isNucleicAcid }">是</button>
            </div>
          </div>
        </div>
      </div>
      <div class="read" @click="agreeInfo.isReal = !agreeInfo.isReal">
        <img v-if="!agreeInfo.isReal" src="~@/assets/image/common/common_unchecked.png" alt=""/>
        <img v-else src="~@/assets/image/common/common_tick.png" alt="">
        <span>我已仔细阅读并承诺以上填报信息属实。</span>
      </div>
      <div class="ticket-purchase">
        <button @click="scheduled" :class="{ 'active': agreeInfo.isLocal && agreeInfo.isVaccination && agreeInfo.isNucleicAcid && agreeInfo.isReal }">开始购票</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "group-notice",
  props: {
    currentItem: {
      type: Object,
    },
    groupStateNotice: {
      type: Boolean,
    }
  },
  data(){
    return {
      agreeInfo: {
        isLocal: null,
        isVaccination: null,
        isNucleicAcid: null,
        isReal: null,
      }
    }
  },
  methods: {
    scheduled(){
      if(this.agreeInfo.isLocal && this.agreeInfo.isVaccination && this.agreeInfo.isNucleicAcid && this.agreeInfo.isReal){
        this.$beyondHiding(false);
        this.$router.push(`/${this.currentItem.shoppingCartUrl}?ticketcode=${this.currentItem.code}`);
      }
    },
    closeStateNotice(){
      this.$emit('closeStateNotice')
    }
  }
};
</script>

<style scoped lang='less'>
.mask{
  background: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99999;
  .group-notice{
    background: #FFFFFF;
    border-radius: .44rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 9.2rem;
    max-height: 14.6667rem;
    // overflow: scroll;
    padding: .4rem 0;
    display: flex;
    flex-direction: column;
    h1{
      font-size: .4rem;
      font-weight: bold;
      color: #333333;
      line-height: .6667rem;
      text-align: center;
    };
    .content{
      flex: 1;
      overflow-y: scroll;
      .source{
        font-size: .32rem;
        color: #333333;
        line-height: .56rem;
        margin-top: .2rem;
        text-indent: 2em;
        text-align: justify;
        padding: 0 .4rem;
        .important{
          color: #FF372B;
        }
      };
      .notes{
        margin-top: .3333rem;
        padding: 0 .4rem;
        .notes-item{
          margin-bottom: .4rem;
          &:last-child{
            margin-bottom: 0;
          }
          .title{
            font-size: .32rem;
            color: #333333;
            line-height: .56rem;
            i{
              color: #FF372B;
              margin-right: .2rem;
            }
          }
          .choice{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: .3333rem;
            button{
              width: 4rem;
              height: .96rem;
              background: #F0F0F0;
              border-radius: .56rem;
              font-size: .32rem;
              color: #333333;
              line-height: .56rem;
            }
          }
        }
      };
    }
    .read{
      margin-top: .2667rem;
      background: rgba(62, 165, 96, 0.12);
      height: .6667rem;
      padding: 0 .4rem;
      line-height: .6667rem;
      display: flex;
      align-items: center;
      img{
        width: .3867rem;
        height: .3867rem;
      }
      span{
        margin-left: .08rem;
        font-size: .32rem;
        color: #3EA560;
        line-height: .44rem;
      }
    }
    .ticket-purchase{
      margin-top: .2667rem;
      padding: 0 .4rem;
      button{
        height: .96rem;
        background: #E7E7E7;
        border-radius: .6667rem;
        width: 100%;
        font-size: .48rem;
        font-weight: bold;
        color: #FFFFFF;
        line-height: .96rem;
        text-align: center;
      }
    }
  }
}

.active{
  background: #3EA560 !important;
  color: #FFFFFF !important;
}
</style>
